export const debug = (args, ...rest) => {
  if (process.env.NODE_ENV !== 'development') return;
  // eslint-disable-next-line no-console
  console.log(args, ...rest);
};
